module.exports = __webpack_public_path__ + "img/20.b60a92fd.jpg";